export default (num: unknown) => Number(num).toLocaleString('EN-en')
